// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top-button {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #3fb9ea;
  color: #d60000;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  z-index: 999;
  transform: scale(0);
}
.scroll-to-top-button i {
  font-size: 20px;
}

.scroll-to-top-button.visible {
  opacity: 1;
  transform: scale(1);
}`, "",{"version":3,"sources":["webpack://./src/Defaults/ScrollTop/Style.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,yBANO;EAOP,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,gEAAA;EACA,YAAA;EACA,mBAAA;AAFJ;AAII;EACI,eAAA;AAFR;;AAMA;EACI,UAAA;EACA,mBAAA;AAHJ","sourcesContent":["// ** Color Variables\r\n$main-clr: #3fb9ea;\r\n\r\n.scroll-to-top-button {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    left: 20px;\r\n    background-color: $main-clr;\r\n    color: #d60000;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out; // Added transform property for animation\r\n    z-index: 999;\r\n    transform: scale(0); // Initial scale to make it invisible\r\n\r\n    i {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n.scroll-to-top-button.visible {\r\n    opacity: 1;\r\n    transform: scale(1); // Scale it up when visible\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
